import Behaviour, { mix } from '@/core/Behaviour'
import { ScreenMixin } from '@/core/modules/'
import anime from 'animejs'
import SponLax from 'sponlax'

export default class BlockReveal extends mix(Behaviour).with(ScreenMixin) {
	$inviewSelector = '[data-img-reveal]'

	sponlaxOptions = {
		rootMargin: '0px',
		threshold: 0,
		shouldUnObserve: () => true,
		onEnter: ($node) => {
			anime({
				targets: $node.querySelector('*'),
				duration: 600,
				'-webkit-clip-path': 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
				clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
				easing: 'cubicBezier(.77,0,.175,1)'
			})

			anime({
				targets: $node.querySelector('img'),
				scale: [1.1, 1],
				duration: 600,
				easing: 'cubicBezier(.77,0,.175,1)'
			})
		}
	}

	mount = () => {
		// const $inviewElements = [...document.querySelectorAll(this.$inviewSelector)]
		// $inviewElements.forEach((element) => {
		// 	const $imgCover = domify('<div class="c-reveal c-reveal--fade-scale bg-white absolute pin w-full h-full"></div>')
		// 	element.appendChild($imgCover)
		// })

		this.sponlax = new SponLax(this.$inviewSelector, this.sponlaxOptions)

		this.init()
	}

	routes = {
		enter: () => {
			// const $inviewElements = [...document.querySelectorAll(this.$inviewSelector)]
			// $inviewElements.forEach((element) => {
			// 	const $imgCover = domify('<div class="c-reveal c-reveal--fade-scale bg-white absolute pin w-full h-full"></div>')
			// 	element.appendChild($imgCover)
			// })

			this.sponlax = new SponLax(this.$inviewSelector, this.sponlaxOptions)
		},
		exit: () => {
			if (this.sponlax) this.sponlax.disconnect()
		}
	}

	unmount = () => {
		if (this.sponlax) this.sponlax.disconnect()
	}
}



if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
